// extracted by mini-css-extract-plugin
module.exports = {"actionLinks":"Avatar_actionLinks__MOaZt","dropdown":"Avatar_dropdown__YwVdA","trigger":"Avatar_trigger__l5ADW"};